import { ProductDraftContent } from "./interface/InterfaceProduct";

export function ValidateNotEmpty(value: string | number) {
  if (value === `{"en":"","km":"","zh":""}`) {
    return false;
  } else if (value === undefined) {
    return false;
  } else if (value === 0) {
    return false;
  } else if (value === "") {
    return false;
  } else {
    return true;
  }
}

export function FirstValidation(val: ProductDraftContent) {
  const firstTabValidation = [
    ["title", ValidateNotEmpty(val.title!)],
    ["description", ValidateNotEmpty(val.description!)],
    ["supplier_code", ValidateNotEmpty(val.supplier_code!)],
  ];

  for (const first of firstTabValidation) {
    if (first[1] === false) {
      return {
        status: false,
        error: {
          name: first[0],
          message: "",
        },
      };
    }
  }
  return {
    status: true,
    error: {
      name: "",
      message: "",
    },
  };
}

export function SecondValidation(val: ProductDraftContent) {
  const secondValidation = [
    ["category_id", ValidateNotEmpty(val.category_id!)],
    ["salesprice", ValidateNotEmpty(val.saleprice!)],
    ["weight", ValidateNotEmpty(val.weight!)],
    ["dimension_width", ValidateNotEmpty(val.dimension_width!)],
    ["dimension_height", ValidateNotEmpty(val.dimension_height!)],
    ["dimension_length", ValidateNotEmpty(val.dimension_length!)],
    ["colorus", ValidateNotEmpty(val.colours!)],
    ["size", ValidateNotEmpty(val.size!)],
  ];

  for (const second of secondValidation) {
    if (second[1] === false) {
      return {
        status: false,
        error: {
          name: second[0],
          message: "",
        },
      };
    }
  }
  return {
    status: true,
    error: {
      name: "",
      message: "",
    },
  };
}
